export const letterColors = {
  A: '#FF4500',
  B: '#006400',
  C: '#00008B',
  D: '#8B008B',
  E: '#1E90FF',
  F: '#8B0000',
  G: '#556B2F',
  H: '#483D8B',
  I: '#A52A2A',
  J: '#2F4F4F',
  K: '#8B4513',
  L: '#228B22',
  M: '#4B0082',
  N: '#8A2BE2',
  O: '#000080',
  P: '#8B0000',
  Q: '#2F4F4F',
  R: '#483D8B',
  S: '#A52A2A',
  T: '#8B4513',
  U: '#228B22',
  V: '#4B0082',
  W: '#8A2BE2',
  X: '#000080',
  Y: '#8B0000',
  Z: '#2F4F4F',
};
